import { BrowserRouter, Routes, Route } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "@/store";
import { AppLayout, AuthLayout } from "@/components/layout";
import { PrivateRoute } from "@/components/PrivateRoute";
import { RoleBasedRoute } from "@/components/RoleBasedRoute";
import Dashboard from "@/pages/dashboard/Dashboard";
import SettingsPage from "@/pages/settings/SettingsPage";
import DeviceSetupPage from "@/pages/settings/DeviceSetupPage";
import HistoryPage from "@/pages/settings/HistoryPage";
import { SignIn } from "@/pages/auth/SignIn/SignIn";
import DevicePage from "@/pages/device/DevicePage";
import OperationDataPage from "@/pages/device/OperationDataPage";
import DevicesPage from "@/pages/device/DevicesPage";
import SitesPage from "@/pages/sites/SitesPage";
import AnalyticsPage from "@/pages/analytics/AnalyticsPage";
import WiFiSignalPage from "@/pages/analytics/WiFiSignalPage";
import FlowRatePage from "@/pages/analytics/FlowRatePage";
import PhValuePage from "@/pages/analytics/PhValuePage";
import OrpValuePage from "@/pages/analytics/OrpValuePage";
import WaterTemperaturePage from "@/pages/analytics/WaterTemperaturePage";
import AmbientTemperaturePage from "@/pages/analytics/AmbientTemperaturePage";
import AnalyticsLayout from "@/pages/analytics/AnalyticsLayout";
import AuxStatusPage from "@/pages/analytics/AuxStatusPage";
import ScheduleTimelinePage from "@/pages/schedule/ScheduleTimelinePage";
import ScheduleOverviewPage from "@/pages/schedule/ScheduleOverviewPage";
import UsersSharingPage from "@/pages/settings/UsersSharingPage";
import SensorsCalibrationPage from "@/pages/settings/SensorsCalibrationPage";
import DeviceSettingsPage from "@/pages/settings/DeviceSettingsPage";
import CollectionTasksPage from "@/pages/settings/CollectionTasksPage";

import Loading from "@/components/Loading";
import { useAppSelector } from "@/store";
import type { RootState } from "@/store";
import ThemeManager from "@/components/ThemeManager";

// import '@/styles/index.css';

function App() {
  const loadingActive = useAppSelector((state) => state.app.loading);

  return (
    <PersistGate loading={null} persistor={persistor}>
      <ThemeManager />
      <BrowserRouter>
        <Routes>
          {/* 认证路由 */}
          <Route element={<AuthLayout />}>
            <Route path="/" element={<SignIn />} />
            <Route path="/login" element={<SignIn />} />
            {/* <Route path="/create-user" element={<div>Create User Page</div>} />
              <Route path="/create-installer" element={<div>Create Installer Page</div>} />
              <Route path="/forgot-password" element={<div>Forgot Password Page</div>} /> */}
          </Route>

          {/* 受保护路由 */}
          <Route element={<PrivateRoute />}>
            <Route element={<AppLayout />}>
              {/* 所有角色共享的路由 */}
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/devices" element={<DevicesPage />} />
              <Route path="/schedule-timeline" element={<ScheduleTimelinePage />} />
              <Route path="/schedule-overview" element={<ScheduleOverviewPage />} />

              {/* Analytics 路由 */}
              <Route element={<AnalyticsLayout />}>
                <Route path="/analytics" element={<AnalyticsPage />} />
                <Route
                  path="/analytics/wifi-signal"
                  element={<WiFiSignalPage />}
                />
                <Route path="/analytics/flow-rate" element={<FlowRatePage />} />
                <Route path="/analytics/ph-value" element={<PhValuePage />} />
                <Route path="/analytics/orp-value" element={<OrpValuePage />} />
                <Route
                  path="/analytics/water-temperature"
                  element={<WaterTemperaturePage />}
                />
                <Route
                  path="/analytics/ambient-temperature"
                  element={<AmbientTemperaturePage />}
                />
                <Route path="/analytics/aux-status" element={<AuxStatusPage />} />
              </Route>

              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/settings/device-setup" element={<DeviceSetupPage />} />
              <Route path="/settings/device-settings" element={<DeviceSettingsPage />} />
              <Route path="/settings/history" element={<HistoryPage />} />
              <Route path="/settings/users-sharing" element={<UsersSharingPage />} />
              <Route path="/settings/sensors-calibration" element={<SensorsCalibrationPage />} />

              {/* 管理员和普通用户可访问的路由 */}
              <Route
                element={<RoleBasedRoute allowedRoles={["admin", "user"]} />}
              >
                <Route path="/sites/*" element={<SitesPage />} />
                {/* <Route path="/analytics/*" element={<div>Analytics Page</div>} /> */}
              </Route>

              {/* 仅管理员可访问的路由 */}
              <Route element={<RoleBasedRoute allowedRoles={["admin"]} />}>
                <Route path="/operation" element={<DevicePage />} />
                <Route
                  path="/operation/:deviceId/operations"
                  element={<OperationDataPage />}
                />
                <Route path="/collection-tasks" element={<CollectionTasksPage />} />
              </Route>

              {/* 仅安装人员可访问的路由 */}
              <Route element={<RoleBasedRoute allowedRoles={["installer"]} />}>
                <Route
                  path="/installations/*"
                  element={<div>Installations Page</div>}
                />
                <Route path="/reports/*" element={<div>Reports Page</div>} />
              </Route>
            </Route>
          </Route>
        </Routes>
        <Loading active={loadingActive} />
      </BrowserRouter>
    </PersistGate>
  );
}

export default App;
